// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/billing/v1/start_subscription_checkout.proto (package protos.vision.billing.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/billing/v1/start_subscription_checkout.proto.
 */
export const file_vision_billing_v1_start_subscription_checkout: GenFile = /*@__PURE__*/
  fileDesc("CjN2aXNpb24vYmlsbGluZy92MS9zdGFydF9zdWJzY3JpcHRpb25fY2hlY2tvdXQucHJvdG8SGHByb3Rvcy52aXNpb24uYmlsbGluZy52MSKRAQogU3RhcnRTdWJzY3JpcHRpb25DaGVja291dFJlcXVlc3QSUQoGcGFyYW1zGAEgASgLMkEucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLlN0YXJ0U3Vic2NyaXB0aW9uQ2hlY2tvdXRSZXF1ZXN0LlBhcmFtcxoaCgZQYXJhbXMSEAoIcGxhbl9rZXkYASABKAkiqwEKIVN0YXJ0U3Vic2NyaXB0aW9uQ2hlY2tvdXRSZXNwb25zZRJSCgZyZXN1bHQYASABKAsyQi5wcm90b3MudmlzaW9uLmJpbGxpbmcudjEuU3RhcnRTdWJzY3JpcHRpb25DaGVja291dFJlc3BvbnNlLlJlc3VsdBoyCgZSZXN1bHQSFAoMY2hlY2tvdXRfdXJsGAEgASgJEhIKCnNlc3Npb25faWQYAiABKAliBnByb3RvMw");

/**
 * @generated from message protos.vision.billing.v1.StartSubscriptionCheckoutRequest
 */
export type StartSubscriptionCheckoutRequest = Message<"protos.vision.billing.v1.StartSubscriptionCheckoutRequest"> & {
  /**
   * @generated from field: protos.vision.billing.v1.StartSubscriptionCheckoutRequest.Params params = 1;
   */
  params?: StartSubscriptionCheckoutRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.StartSubscriptionCheckoutRequest.
 * Use `create(StartSubscriptionCheckoutRequestSchema)` to create a new message.
 */
export const StartSubscriptionCheckoutRequestSchema: GenMessage<StartSubscriptionCheckoutRequest> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_start_subscription_checkout, 0);

/**
 * @generated from message protos.vision.billing.v1.StartSubscriptionCheckoutRequest.Params
 */
export type StartSubscriptionCheckoutRequest_Params = Message<"protos.vision.billing.v1.StartSubscriptionCheckoutRequest.Params"> & {
  /**
   * @generated from field: string plan_key = 1;
   */
  planKey: string;
};

/**
 * Describes the message protos.vision.billing.v1.StartSubscriptionCheckoutRequest.Params.
 * Use `create(StartSubscriptionCheckoutRequest_ParamsSchema)` to create a new message.
 */
export const StartSubscriptionCheckoutRequest_ParamsSchema: GenMessage<StartSubscriptionCheckoutRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_start_subscription_checkout, 0, 0);

/**
 * @generated from message protos.vision.billing.v1.StartSubscriptionCheckoutResponse
 */
export type StartSubscriptionCheckoutResponse = Message<"protos.vision.billing.v1.StartSubscriptionCheckoutResponse"> & {
  /**
   * @generated from field: protos.vision.billing.v1.StartSubscriptionCheckoutResponse.Result result = 1;
   */
  result?: StartSubscriptionCheckoutResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.StartSubscriptionCheckoutResponse.
 * Use `create(StartSubscriptionCheckoutResponseSchema)` to create a new message.
 */
export const StartSubscriptionCheckoutResponseSchema: GenMessage<StartSubscriptionCheckoutResponse> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_start_subscription_checkout, 1);

/**
 * @generated from message protos.vision.billing.v1.StartSubscriptionCheckoutResponse.Result
 */
export type StartSubscriptionCheckoutResponse_Result = Message<"protos.vision.billing.v1.StartSubscriptionCheckoutResponse.Result"> & {
  /**
   * @generated from field: string checkout_url = 1;
   */
  checkoutUrl: string;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;
};

/**
 * Describes the message protos.vision.billing.v1.StartSubscriptionCheckoutResponse.Result.
 * Use `create(StartSubscriptionCheckoutResponse_ResultSchema)` to create a new message.
 */
export const StartSubscriptionCheckoutResponse_ResultSchema: GenMessage<StartSubscriptionCheckoutResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_start_subscription_checkout, 1, 0);

